import { CaseData, ApiResponse } from 'app/types-shared';
import { RemoteData } from 'app/infrastructure/remote-data/remote-data';
import { endpoints } from './endpoints';
import { CaseDraftRow } from 'app/area/my-case-drafts/types-store';

export const api = {
  getUserDrafts: async (): Promise<CaseDraftRow[]> => {
    const response: any = await new RemoteData(endpoints.userDrafts).resource<CaseDraftRow[]>().all();
    return response.data;
  },

  deleteDraft: async (draftId: number) => {
    return new RemoteData(endpoints.deleteCaseDraft)
      .resource<ApiResponse<CaseData>>()
      .withId(draftId)
      .httpDelete(draftId);
  }
};
